// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"635":"2ee59a7b","726":"135e4261","827":"72d63a06"}[chunkId] + ".chunk.js");